import SignUpTaxiOfficerFormData from "./types/sign-up-taxi-officer-form-data";
import SignUpTaxiOfficerTokenPayload from "../../common/types/sign-up-taxi-officer-token-payload";
import SignUpTaxiOfficerDisabledFormFields from "./types/sign-up-taxi-officer-disabled-form-fields";
import TaxiOfficerAddParams from "../../../../../common/services/taxi-officer/add/taxi-officer-add-params";

const createSignUpRequest = (
  userData: SignUpTaxiOfficerFormData,
  taxiCorporationId: string,
): TaxiOfficerAddParams => ({
  firstName: userData.firstName.trim(),
  lastName: userData.lastName.trim(),
  phoneNumber: userData.mobile,
  alternativePhoneNumber: userData.alternativeMobile,
  email: userData.email.trim(),
  username: userData.username.trim(),
  password: userData.password,
  taxiCorporationUuid: taxiCorporationId,
});

const createDisabledFormFieldsConfig = (
  tokenPayload: SignUpTaxiOfficerTokenPayload,
): SignUpTaxiOfficerDisabledFormFields => {
  return {
    email: !!tokenPayload.user_data.email,
    firstName: !!tokenPayload.user_data.first_name,
    lastName: !!tokenPayload.user_data.last_name,
    mobile:
      !!tokenPayload.user_data.mobile_primary &&
      !!tokenPayload.user_data.mobile_primary_prefix,
    alternativeMobile:
      !!tokenPayload.user_data.mobile_secondary &&
      !!tokenPayload.user_data.mobile_secondary_prefix,
    username: !!tokenPayload.user_data.username,
  };
};

const createFormData = (
  tokenPayload: SignUpTaxiOfficerTokenPayload,
): SignUpTaxiOfficerFormData => {
  return {
    email: tokenPayload.user_data.email ?? "",
    password: "",
    passwordRepeat: "",
    username: tokenPayload.user_data.username ?? "",
    firstName: tokenPayload.user_data.first_name ?? "",
    lastName: tokenPayload.user_data.last_name ?? "",
    mobile: {
      dialingCode: tokenPayload.user_data.mobile_primary_prefix ?? "",
      number: tokenPayload.user_data.mobile_primary ?? "",
    },
    alternativeMobile: {
      dialingCode: tokenPayload.user_data.mobile_secondary_prefix ?? "",
      number: tokenPayload.user_data.mobile_secondary ?? "",
    },
  };
};

const signUpTaxiOfficerFactory = {
  createSignUpRequest,
  createFormData,
  createDisabledFormFieldsConfig,
};

export default signUpTaxiOfficerFactory;
